<template>
    <div class="flex gap-2 items-center shrink-0">
        <UButton
            v-if="actionable"
            size="sm"
            label="Behandle"
            :disabled="blockingDependencies.length > 0 || assignment.status === AssignmentStatus.Deleted"
            @click="handleAction"
        />
        <UTooltip
            v-if="blockingDependencies.length > 0"
            :delay-duration="0"
            arrow
            :ui="{
                content: 'h-fit overflow-visible',
                text: 'whitespace-pre-line p-1',
            }"
        >
            <template #default>
                <i class="i-ph-lock-simple text-xl" />
            </template>

            <template #content>
                <div v-for="depAss in blockingDependencies" :key="depAss.uuid" class="flex flex-col p-2 gap-1">
                    <span>Oppgaven er blokkert av: {{ depAss.assignmentNo }} - {{ depAss.title }}</span>
                    <div class="cursor-pointer underline hover:no-underline" @click="() => handleClickDependency(depAss)">Gå til oppgaven</div>
                </div>
            </template>
        </UTooltip>
        <assignment-dropdown-actions
            v-if="assignment"
            class="ml-auto"
            :assignment
            :params
        />
    </div>
</template>

<script setup lang="ts">

import {handleBookkeepingActionable} from '@/assignments/BookkeepingActionable/bookkeepingHandler'
import {Assignment, AssignmentCellRenderParams, AssignmentDependency, AssignmentStatus} from '@/assignments/Assignment.type'
import {Bookkeepable} from '@/assignments/BookkeepingActionable/BookkeepingActionable.type'
import {computed, inject, Ref} from 'vue'
import {usePanelManager} from '@tritt/multipanel'
import {CREATE_TRANSACTION} from '@/transaction/create-transaction'
import AssignmentDropdownActions from '@/assignments/AssignmentDropdownActions.vue'

const {setPanelPath} = usePanelManager()

const props = defineProps({
    params: {
        type: Object as () => AssignmentCellRenderParams,
        required: true
    }
})

const assignment = computed<Assignment>(() => {
    return props.params.data as Assignment
})

const actionable = computed<Bookkeepable | undefined>(() => {
    return assignment.value.context as Bookkeepable
})

const blockingDependencies = computed(() => {
    return assignment.value?.dependencies.filter(dep => {
        return dep.status !== 'completed'
    })
})

const panelId: Ref<number> | undefined = inject('panelId')

const handleAction = () => {
    if (actionable.value) {
        console.debug(assignment)
        console.debug(assignment.value)
        handleBookkeepingActionable(actionable.value, assignment.value)
        setPanelPath({componentName: CREATE_TRANSACTION.componentName, queryValues: {}, panelId: panelId?.value ? panelId?.value + 1 : 1})
    }
}

const handleClickDependency = (dependency: AssignmentDependency) => {
    props.params.context.openAssignmentDetails(dependency.uuid)
}

</script>

<style scoped>

</style>